<template>
  <div>
    <div
      class="flex flex-row"
      :class="{'justify-between': pageSizeStart}"
    >
      <div
        class="w-1/3 flex"
        :class="{'hidden': pageSizeStart}"
      >
        <slot name="start" />
      </div>
      <div
        class="flex flex-row"
        :class="{
          'w-1/3 justify-center items-center': !pageSizeStart
        }"
      >
        <div
          class="flex flex-row justify-center items-center"
          :class="{'hidden': hidePageLimitSelection}"
        >
          <p class="self-center mr-3">
            Show
          </p>
          <vs-select
            v-model="pageSize"
            icon="unfold_more"
            color="secondary"
          >
            <vs-select-item
              v-for="(item, index) of pageSizes"
              :key="index"
              :value="item.value"
              :text="item.text"
            />
          </vs-select>
          <p class="self-center ml-3">
            Data
          </p>
        </div>
      </div>
      <div
        v-if="!hideSearch"
        class="flex flex-row"
        :class="{'w-1/3 justify-end': !pageSizeStart,
                 'self-start': searchSelfStart,
                 'self-center': !searchSelfStart
        }"
      >
        <vs-input
          icon-no-border
          :class="['search', isSearchHasBorder ? 'border border-primary rounded-md' : '']"
          v-model="search"
          icon="search"
          placeholder="Search here..."
          @keyup.enter="handleSearch"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'

export default {
  props: {
    pageSizeStart: {
      type: Boolean,
      default: () => true
    },
    searchSelfStart: {
      type: Boolean,
      default: () => false
    },
    hideSearch: {
      type: Boolean,
      default: () => false
    },
    hidePageLimitSelection: {
      type: Boolean,
      default: () => false
    },
    isSearchHasBorder: {
      type: Boolean,
      default: () => false
    },
    isSecondaryTable: {
      type: Boolean,
      default: () => false
    },
    defaultSearch: {
      type: String,
      default: () => null
    }
  },
  data() {
    return {
      search: null
    }
  },
  computed: {
    pageSize: {
      get() {
        return this.isSecondaryTable
          ? this.$store.getters['Table/secondaryTablePageSize']
          : this.$store.getters['Table/pageSize'];
      },
      set(val) {
        this.$store.commit(`Table/SET_PAGE_SIZE${this.isSecondaryTable ? '_SECONDARY_TABLE' : ''}`, val);
        this.fetch();
      }
    },
    pageSizes(){ 
      return this.isSecondaryTable 
        ? this.$store.getters['Table/secondaryTablePageSizes']
        : this.$store.getters['Table/pageSizes']
    },
    totalPage(){
      return this.isSecondaryTable
        ? this.$store.getters['Table/secondaryTableTotalPage']
        : this.$store.getters['Table/totalPage']
    }
  },
  watch: {  
    search: {
      immediate: true,
      handler(val) {
        if (!!this.defaultSearch && val !== null) {
          // Fetch and set TABLE/SET_SEARCH done manually in caller
          // in case there is active filter
          return
        }
        if (val !== null && !val.length) {
          this.$store.commit(`Table/SET_SEARCH${this.isSecondaryTable ? '_SECONDARY_TABLE':''}`, null)
          this.fetch()
        }
      }
    },
    defaultSearch: {
      immediate: true,
      handler(val) {
        if (val) {
          this.search = val
        }
      }
    }
  },
  methods: {
    fetch: debounce(function () {
      this.$emit('fetch')
    }, 500),
    handleSearch() {
      this.$store.commit(`Table/SET_SEARCH${this.isSecondaryTable ? '_SECONDARY_TABLE':''}`, this.search)
      this.fetch()
    },
    resetSearch() {
      this.search = null;
      this.$store.commit(`Table/SET_SEARCH${this.isSecondaryTable ? '_SECONDARY_TABLE':''}`, null);
    }
  },
  mounted() {
    this.$on('reset-search', () => {
      this.resetSearch();
      this.fetch()
    })
  },
  beforeDestroy() {
    this.resetSearch();
  }
}
</script>

<style lang="scss" scoped>
/deep/.con-select {
  @apply w-auto rounded-lg;
}

/deep/.vs-con-input-label {
  width: 200px !important;
}

/deep/.input-select-con {
  max-width: 3.5rem;
}

/deep/.vs-select--input {
  @apply pr-0 rounded-lg;

  border: 0 none transparent;
}

/deep/.vs-select--icon {
  right: 0.25px;
  @apply text-primary;
  font-size: 20px;
}

/deep/.vs-input--input {
  @apply bg-white;
  @apply h-12 rounded-lg;
  padding-left: calc(1rem + 24px) !important;
  border: 0 solid transparent !important;
}

/deep/.vs-input--placeholder {
  padding-left: calc(1rem + 24px) !important;
}

/deep/ .vs-con-input-label {
  width: 210px !important;
}

/deep/.vs-input--icon {
  top: auto;
  left: 0.5rem;
  @apply text-primary;
}
</style>
